/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import Img from "gatsby-image"
import { getFluidFromAsset } from "frontend/src/utils/gatsbyImageHelpers"
import { Fragment } from "react"

const SocialProof = ({
  data: {
    showSocialProof = false,
    influencerName = "",
    number = 0,
    productName = "",
    productGender = "",
    image,
  },
}) => {
  let possessionPronoun
  switch (productGender) {
    case "f": {
      possessionPronoun = "unsere"
      break
    }
    case "m": {
      possessionPronoun = "unseren"
      break
    }
    case "n": {
      possessionPronoun = "unser"
      break
    }
    case "p": {
      possessionPronoun = "unsere"
      break
    }
    default: {
      possessionPronoun = "unsere"
    }
  }
  return (
    <Fragment>
      {showSocialProof && (
        <div
          sx={{
            display: "flex",
            backgroundColor: "#f0f3f5",
            mx: 6,
            mt: 3,
            mb: 1,
            px: 4,
            py: 3,
            alignItems: "center",
            borderRadius: "10px",
            height: ["38px", "38px", "49px", "38px"],
          }}
        >
          <Img fluid={getFluidFromAsset(image, 100)} sx={{ width: "36px", mr: 2 }} />
          <p
            sx={{
              fontFamily: "body",
              fontSize: "9px",
              lineHeight: ["122%", "111%", "122%"],
              textAlign: "left",
            }}
          >
            <span sx={{ fontWeight: "bold" }}>{influencerName}</span>
            <span> und </span>
            <span sx={{ fontWeight: "bold" }}>{number} andere</span>
            <span> lieben </span>
            <span>
              {possessionPronoun} {productName}
            </span>
          </p>
        </div>
      )}
    </Fragment>
  )
}

export { SocialProof }
